import LTEBox from './LTEBox';

export default LTEBox;
